export default __webpack_public_path__ + "static/media/faq.ef5d36ae.png";